// import Vue from 'vue'
// import teinte from '../../../src/App.vue'
import httpService from "../../components/service";

export const shade = {
    namespaced: true,
    state: {
        items: {},
        shades: [],
        relatedShadesInfos: [],
        relatedShades: {},
        shadeProperties: {},
        editShadeID: ""
    },
    getters: {
        getAllShades: state => {
            return state.shades;
        },
        getShadesLength: state => state.shades.length,
        getRelatedShades: state => state.relatedShades,
        getRelatedShadesInfos: state => state.relatedShadesInfos,
        getShadesProperties: (state, getter) => {
            return state.shadeProperties;
        },
        getEditShadeID(state) {
            return state.editShadeID;
        }
    },
    mutations: {
        POPULATE_SHADES(state, shades) {
            state.shades = shades;
        },
        ENRICH_SHADES(state, data) {
            state.relatedShades = data;
        },
        ENRICH_SHADES_INFO(state, data) {
            state.relatedShadesInfos = data;
        },
        PROPERTIES_SHADES(state, data) {
            state.shadeProperties = data;
        },
        SET_EDIT_SHADE_ID(state, editShadeID) {
            state.editShadeID = editShadeID;
        }
    },
    actions: {
        populate: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/components").then(data => {
                    let items = {};
                    for (let item of data.data) {
                        items[item.id] = item;
                    }
                    context.commit("POPULATE_SHADES", items);
                    resolve();
                });
            });
        },
        async getRelatedShades(context, data) {
            const response = await httpService.get(
                "/components/" +
                    data.id +
                    "/shades?filterbyzone=" +
                    data.zone +
                    "&disablecampaign=" +
                    data.disablecampaign +
                    "&isactivated=" +
                    data.isactivated
            );
            context.commit("ENRICH_SHADES", response.data);
            return response;
        },
        async getRelatedShadesInfosAction(context, data) {
            const resp = await httpService.get(
                "/components/" +
                    data.id +
                    "/shades-hover?filterbyzone=" +
                    data.zone +
                    "&disablecampaign=" +
                    data.disablecampaign +
                    "&isactivated=" +
                    data.isactivated
            );
            if (resp.code) throw new Error(resp.message);
            context.commit("ENRICH_SHADES_INFO", resp);
            return resp;
        },
        getShadesProperties: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/admin/shades/properties").then(response => {
                    context.commit("PROPERTIES_SHADES", response);
                    resolve(response);
                });
            });
        },
        setEditShadeID(context, editShadeID) {
            context.commit("SET_EDIT_SHADE_ID", editShadeID);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/shades/shade.js